import { takeLatest, all, put } from 'redux-saga/effects';

import { requestAndSet, sendToHelium } from 'utils/helpers';

import { kiosksActions } from '../slices/kiosksSlice';

function* fetchKiosksSaga(
  action: ReturnType<typeof kiosksActions.fetchKiosks>,
): Generator {
  const { orgId } = action.payload;
  yield requestAndSet('listAllKiosk', [orgId], {
    createSetterAction: kiosksActions.setKiosks,
    loadingAction: (v: boolean) =>
      kiosksActions.setLoading({ key: 'fetchKiosksLoading', value: v }),
  });
}

function* describeKioskSaga(
  action: ReturnType<typeof kiosksActions.describeKiosk>,
): Generator {
  const { orgId, kioskId } = action.payload;
  yield requestAndSet('describeKiosk', [orgId, kioskId], {
    createSetterAction: kiosksActions.setSelectedKiosk,
    loadingAction: (v: boolean) =>
      kiosksActions.setLoading({ key: 'describeKioskLoading', value: v }),
  });
}

function* getKioskLocationsSaga(
  action: ReturnType<typeof kiosksActions.getKioskLocations>,
): Generator {
  yield requestAndSet(
    'getKioskLocations',
    [action.payload.orgId, action.payload.kioskId],
    {
      createSetterAction: kiosksActions.setKioskLocations,
      loadingAction: (v: boolean) =>
        kiosksActions.setLoading({ key: 'getKioskLocationsLoading', value: v }),
    },
  );
}
function* createKioskSaga(
  action: ReturnType<typeof kiosksActions.createKiosk>,
): Generator {
  const { orgId, kiosk } = action.payload;
  yield sendToHelium('insertKiosk', [orgId], kiosk, {
    loadingAction: (v: boolean) =>
      kiosksActions.setLoading({ key: 'createKioskLoading', value: v }),
  });
  yield put(kiosksActions.fetchKiosks({ orgId }));
}

function* updateKioskSaga(
  action: ReturnType<typeof kiosksActions.updateKiosk>,
): Generator {
  const { orgId, kioskId, kiosk } = action.payload;
  yield sendToHelium('updateKiosk', [orgId, kioskId], kiosk, {
    loadingAction: (v: boolean) =>
      kiosksActions.setLoading({ key: 'updateKioskLoading', value: v }),
  });
  yield put(kiosksActions.fetchKiosks({ orgId }));
}

function* deleteKioskSaga(
  action: ReturnType<typeof kiosksActions.deleteKiosk>,
): Generator {
  const { orgId, kioskId } = action.payload;
  yield sendToHelium(
    'deleteKiosk',
    [orgId, kioskId],
    {},
    {
      loadingAction: (v: boolean) =>
        kiosksActions.setLoading({ key: 'deleteKioskLoading', value: v }),
    },
  );
  yield put(kiosksActions.fetchKiosks({ orgId }));
}

function* updateKioskAppearanceSaga(
  action: ReturnType<typeof kiosksActions.updateAppearanceConfig>,
): Generator {
  const { orgId, kioskId, appearanceConfig } = action.payload;
  const result = yield sendToHelium(
    'updateKioskAppearance',
    [orgId, kioskId],
    appearanceConfig,
    {
      loadingAction: (v: boolean) =>
        kiosksActions.setLoading({
          key: 'updateAppearanceConfigLoading',
          value: v,
        }),
    },
  );
  if (result?.statusCode === 200) {
    yield put(kiosksActions.describeKiosk({ orgId, kioskId }));
  }
}

export default function* kiosksSaga(): Generator {
  yield all([
    takeLatest(kiosksActions.fetchKiosks.type, fetchKiosksSaga),
    takeLatest(kiosksActions.describeKiosk.type, describeKioskSaga),
    takeLatest(kiosksActions.createKiosk.type, createKioskSaga),
    takeLatest(kiosksActions.updateKiosk.type, updateKioskSaga),
    takeLatest(kiosksActions.deleteKiosk.type, deleteKioskSaga),
    takeLatest(kiosksActions.getKioskLocations.type, getKioskLocationsSaga),
    takeLatest(
      kiosksActions.createAppearanceConfig.type,
      updateKioskAppearanceSaga,
    ),
    takeLatest(
      kiosksActions.updateAppearanceConfig.type,
      updateKioskAppearanceSaga,
    ),
  ]);
}
